import React from "react"
import { Link } from "react-router-dom"
import PageHeader from "../../components/DashboardComponents/PageHeader"

const TermsOfService = () => (
  <div className="page-content">
    <div className="legal-portal">
      <PageHeader
        className="legal-portal__header"
        title="Terms & Conditions"
        subtitle="Rules for using the Amok Earth portal and related services."
      />

      <div className="legal-portal__content">
      <p className="legal-portal__updated">Last updated: August 22, 2026</p>

      <p>
        These Terms &amp; Conditions (&quot;Terms&quot;) govern your access to
        and use of Amok Earth websites, apps, and related services (the
        &quot;Services&quot;). By creating an account or using the Services, you
        agree to these Terms.
      </p>

      <h2>1. Eligibility &amp; accounts</h2>
      <ul>
        <li>
          You must be able to form a binding contract and meet any age
          requirements in your location.
        </li>
        <li>
          You are responsible for your account credentials and for activity
          under your account.
        </li>
        <li>
          Provide accurate information and keep your profile reasonably up to
          date.
        </li>
        <li>
          Access may require an invitation or approval according to Amok Earth
          onboarding rules.
        </li>
      </ul>

      <h2>2. The Services</h2>
      <p>
        Amok Earth helps creatives collaborate through projects, sessions, city
        hubs, messaging, and related tools. Features may change, and we may add,
        modify, or discontinue parts of the Services with or without notice.
      </p>

      <h2>3. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Violate laws or others&apos; rights</li>
        <li>
          Harass, abuse, or discriminate against other users, or post harmful or
          illegal content
        </li>
        <li>
          Upload malware, attempt unauthorized access, scrape, or disrupt the
          Services
        </li>
        <li>
          Impersonate others or misrepresent your affiliation with a person or
          organization
        </li>
        <li>
          Use the Services to spam, advertise without permission, or exploit
          platform features unfairly
        </li>
      </ul>
      <p>
        We may remove content, restrict features, or suspend accounts that
        violate these Terms or community standards.
      </p>

      <h2>4. Your content</h2>
      <ul>
        <li>
          You retain ownership of content you submit (projects, media, notes,
          messages, etc.).
        </li>
        <li>
          You grant Amok Earth a worldwide, non-exclusive license to host,
          store, display, and process your content as needed to operate and
          improve the Services.
        </li>
        <li>
          You represent that you have the rights needed to submit that content
          and that it does not infringe others&apos; rights.
        </li>
      </ul>

      <h2>5. Collaborations &amp; projects</h2>
      <p>
        Project roles, invitations, collaborator limits, sessions, and related
        permissions are controlled by project owners/admins and platform rules.
        Amok Earth is not a party to private agreements between collaborators
        unless we expressly say otherwise in writing.
      </p>

      <h2>6. Third-party services</h2>
      <p>
        The Services may link to or integrate third-party tools. We are not
        responsible for third-party content, policies, or practices. Your use of
        third-party services is at your own risk and subject to their terms.
      </p>

      <h2>7. Intellectual property</h2>
      <p>
        Amok Earth branding, software, design, and platform materials are owned
        by Amok Earth or its licensors. Except for rights expressly granted, no
        license to our IP is conferred by these Terms.
      </p>

      <h2>8. Disclaimers</h2>
      <p>
        THE SERVICES ARE PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE.&quot;
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        We do not guarantee uninterrupted or error-free operation.
      </p>

      <h2>9. Limitation of liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, AMOK EARTH AND ITS AFFILIATES
        WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
        PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, DATA, OR GOODWILL, ARISING
        FROM YOUR USE OF THE SERVICES. OUR TOTAL LIABILITY FOR ANY CLAIM
        RELATING TO THE SERVICES WILL NOT EXCEED THE AMOUNTS YOU PAID US (IF
        ANY) IN THE TWELVE MONTHS BEFORE THE CLAIM.
      </p>

      <h2>10. Termination</h2>
      <p>
        You may stop using the Services at any time. We may suspend or terminate
        access if you violate these Terms, create risk or legal exposure, or if
        we discontinue the Services. Provisions that by nature should survive
        will survive termination.
      </p>

      <h2>11. Changes to these Terms</h2>
      <p>
        We may update these Terms. We will post changes on this page and update
        the &quot;Last updated&quot; date. Continued use after changes become
        effective constitutes acceptance.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about these Terms can be sent through Amok Earth support
        channels available in the product.
      </p>

      <p className="legal-portal__crosslink">
        See also our <Link to="/privacy-policy">Privacy Policy</Link>.
      </p>
      </div>
    </div>
  </div>
)

export default TermsOfService
